<p-toast></p-toast>
<div *ngIf="errorMessages.length > 0" class="delegateTemplateSliderErrorMessagePlaceHolder">
  <p-messages severity="error">
    <ng-template pTemplate>
      <div class="p-message-wrapper">
        <div>
        <span class="p-message-icon pi pi-times-circle"></span>
        <span class="p-ml-2">{{errorMessageHeaderText}}</span>        
      </div>
      <div>
        <ul>
          <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
        </ul>
      </div>
    </div>
    </ng-template>
  </p-messages>
</div>

<form [formGroup]="delegateForm">
  <div class="general-tab">
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
          label="Scope*"
          [options]="scopes"
          [editable]="false"
          id="delegateScope"
          placeholder="Select Scope"
          formControlName="scope"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields['scope'] }"
          (dropdownChange)="onScopeChange()"
        >
        </bpt-dropdown>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="Assignment*"
          [options]="assignments"
          formControlName="assignments"
          id="delegateAssignment"
          [editable]="false"
          placeholder="Select Assignment"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields['assignments'] }"
        >
        </bpt-dropdown>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required">
        <bpt-dropdown
          label="Delegate From*"
          [options]="delegationFromUserList"
          [editable]="false"
          id="delegateAssignedFrom"
          placeholder="Select User"
          formControlName="delegateFrom"
          [showClear]="true"
          [showFilter]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields['delegateFrom'] }"
          (dropdownChange)="delegationFromandToChange()"
          [disabled] = 'disableDelegationFrom'

        >
        </bpt-dropdown>
      </div>
      <div class="field field-required">
        <bpt-dropdown
          label="Delegate To*"
          [options]="delegationToUserList"
          formControlName="delegateTo"
          id="delegateAssignedTo"
          [editable]="false"
          placeholder="Select Users"
          [showClear]="true"
          [showFilter]="true"
          [multiSelect]="true"
          [valueField]="valueField"
          [labelField]="labelField"
          [ngClass]="{ 'error-highlight': mandatoryFields['delegateTo'] }"
          (dropdownChange)="delegationFromandToChange()"          
        >
        </bpt-dropdown>
      </div>
    </div>
    <div class="fields-row">
      <div class="field field-required"  *ngIf="isStartDateActive"  >
        <bpt-datetime
          id="delegateStartDate"
          [minDate]="minStartDateValue.toString()"
          placeholder="Enter or select a date"
          label="Start Date*"
          formControlName="startDate"
          [ngClass]="{ 'error-highlight': mandatoryFields['startDate'] }"
          (datetimeSelect)="onStartDateChange()"
        ></bpt-datetime>
      </div>
      <div class="field" *ngIf="isEndDateActive">
        <bpt-datetime
          id="delegateEndDate"
          [minDate]="minEndDateValue.toString()"
          placeholder="Enter or select a date"
          label="End Date"
          formControlName="endDate"
        ></bpt-datetime>
      </div>
    </div>
  </div>
  <div class="buttons">
    <p-button
    appPreventDoubleClick
    *ngIf=!isNextBtnDisplayed
      label="Save"
      type="submit"
      id="delegateDetailsSaveButton"
      class="align-right"
      styleClass="bpt-button-compact"
      (debounceClick)="updateDelegate()"
    >
    </p-button>  
    <p-button
    appPreventDoubleClick
    *ngIf=isNextBtnDisplayed
      label="Next"
      type="submit"
      id="delegateDetailsNextButton"
      class="align-right"
      styleClass="bpt-button-compact"
      (debounceClick)="openNextTab()"
    >
    </p-button> 
  </div>
</form>
